<form *ngIf="formBasic && fields" [formGroup]="formBasic"  [ngClass]="{'invalid-submit': invalidSubmit}" >

  <div class="card Loyalty">
    <div class="ui-g">
      <div class="ui-g-12">
        <h2>{{ 'common.storeData' | translate }}</h2>
      </div>
    </div>
    <div class="ui-g ui-g-nopad form-group">

      <div class="ui-g-6 form-control">
        <span class="label" [ngClass]="{'required': !fields.code.nullable}">{{ fields.code.keyName }}</span>
        <input pInputText type="text" formControlName="code" />
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="formBasic" [validation]="fields.code"></app-validation-msg>

        <div *ngIf="!formBasic.controls['code'].valid&&formBasic.controls['code'].dirty">
          <p-message severity="error" text="{{ 'common.required_error' | translate }}" *ngIf="formBasic.controls['code'].required">
          </p-message>
        </div>


      </div>
      <div class="ui-g-6 form-control">
        <span class="label" [ngClass]="{'required': !fields.host_code.nullable}">{{ fields.host_code.keyName }}</span>
        <input pInputText type="text" formControlName="host_code" [attr.disabled]="editMode && disableFieldsPermission ? true : null"/>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="formBasic" [validation]="fields.host_code"></app-validation-msg>
      </div>
      <div class="ui-g-4 form-control">
        <span class="label" [ngClass]="{'required': !fields.name.nullable}">{{ fields.name.keyName }}</span>
        <input pInputText type="text" formControlName="name" />
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="formBasic" [validation]="fields.name"></app-validation-msg>
      </div>
      <div class="ui-g-4 form-control">
        <span class="label" [ngClass]="{'required': !fields.short_name.nullable}">{{ fields.short_name.keyName }}</span>
        <input pInputText type="text" formControlName="short_name" />
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="formBasic" [validation]="fields.short_name"></app-validation-msg>
      </div>
      <div class="ui-g-4 form-control">
        <span class="label" [ngClass]="{'required': !fields.description.nullable}">{{ fields.description.keyName }}</span>
        <input pInputText type="text" formControlName="description" />
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="formBasic" [validation]="fields.description"></app-validation-msg>
      </div>
      <div class="ui-g-6 form-control">
        <span class="label" [ngClass]="{'required': !fields.channel_loyalty_id.nullable}">{{ fields.channel_loyalty_id.keyName }}</span>
        <p-dropdown [options]="channels" [filter]="true" formControlName="channel_loyalty_id" [disabled]="editMode && disableFieldsPermission" placeholder="{{'common.select_something' | translate}}"></p-dropdown>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="formBasic" [validation]="fields.channel_loyalty_id"></app-validation-msg>
      </div>
      <div class="ui-g-6 form-control">
        <span class="label" [ngClass]="{'required': !fields.division_sales_network_id.nullable}">{{ fields.division_sales_network_id.keyName }}</span>
        <p-dropdown [options]="division_sales_networks" [filter]="true" formControlName="division_sales_network_id" [disabled]="editMode && disableFieldsPermission" placeholder="{{'common.select_something' | translate}}"></p-dropdown>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="formBasic" [validation]="fields.division_sales_network_id"></app-validation-msg>

        <div *ngIf="!formBasic.controls['division_sales_network_id'].valid&&formBasic.controls['division_sales_network_id'].dirty">
          <p-message severity="error" text="{{ 'common.required_error' | translate }}" *ngIf="formBasic.controls['division_sales_network_id'].errors.required">
          </p-message>
        </div>

      </div>
      <div class="ui-g-3 ui-md-3 form-control">
        <span class="label" [ngClass]="{'required': !fields.date_start.nullable}">{{ fields.date_start.keyName }}</span>
        <app-kv-calendar
          #dateStartField
          [inputName]="'date_start'"
          [formData]="formBasic"
          [defaultDate]="setDefaultDateStart()"
          [defaultValue]="setDefaultDateStart()"
          [startDateSelector]="true"
          [endDateInputName]="'date_end'"
          [endDateCalendar]="dateEndField"
        ></app-kv-calendar>
        <app-validation-msg [arrayValidators]="[validators.date_start]" [(fireInvalidSubmit)]="invalidSubmit" [(form)]="formBasic" [validation]="fields.date_start"></app-validation-msg>
      </div>
      <div class="ui-g-3 ui-md-3 form-control">
        <span class="label" [ngClass]="{'required': !fields.date_end.nullable}">{{ fields.date_end.keyName }}</span>
        <app-kv-calendar
          #dateEndField
          [inputName]="'date_end'"
          [formData]="formBasic"
          [defaultDate]="setDefaultDateEnd()"
          [defaultValue]="setDefaultDateEnd()"
          [endDateSelector]="true"
          [startDateInputName]="'date_start'"
          [startDateCalendar]="dateStartField"
        ></app-kv-calendar>
        <app-validation-msg [arrayValidators]="[validators.date_end]" [(fireInvalidSubmit)]="invalidSubmit" [(form)]="formBasic" [validation]="fields.date_end"></app-validation-msg>
      </div>
      <div class="ui-g-2 form-control">
        <span class="label">{{ fields.store_surface.keyName }}</span>
        <input pInputText min="0" step="1" type="number" formControlName="store_surface" oninput="this.value = this.value.replace(/[^0-9]/g, '');"/>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="formBasic" [validation]="fields.store_surface"></app-validation-msg>
      </div>
      <div class="ui-g-2 form-control">
        <span class="label">{{ fields.checkouts_number.keyName }}</span>
        <input pInputText min="0" step="1" type="number" formControlName="checkouts_number" oninput="this.value = this.value.replace(/[^0-9]/g, '');" />
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="formBasic" [validation]="fields.checkouts_number"></app-validation-msg>
      </div>
    </div>
  </div>

  <div class="card Loyalty">
    <h2>{{ 'common.address' | translate }}</h2>
    <div class="ui-g ui-g-nopad form-group">

      <div class="ui-g-2 form-control required">
        <span class="label" [ngClass]="{'required': !fields.toponym_id.nullable}">{{ fields.toponym_id.keyName }}</span>
        <p-dropdown [options]="toponyms" [filter]="true" formControlName="toponym_id" placeholder="{{'common.select_something' | translate}}"></p-dropdown>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="formBasic" [validation]="fields.toponym_id"></app-validation-msg>
        <div *ngIf="!formBasic.controls['toponym_id'].valid&&formBasic.controls['toponym_id'].dirty">
          <p-message severity="error" text="{{ 'common.required_error' | translate }}" *ngIf="formBasic.controls['toponym_id'].errors.required">
          </p-message>
        </div>
      </div>
      <div class="ui-g-4 form-control">
        <span class="label" [ngClass]="{'required': !fields.address_1.nullable}">{{ fields.address_1.keyName }}</span>
        <input pInputText type="text" formControlName="address_1" />
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="formBasic" [validation]="fields.address_1"></app-validation-msg>
      </div>
      <div class="ui-g-4 form-control">
        <span class="label" [ngClass]="{'required': !fields.address_2.nullable}">{{ fields.address_2.keyName }}</span>
        <input pInputText type="text" formControlName="address_2" />
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="formBasic" [validation]="fields.address_2"></app-validation-msg>
      </div>
      <div class="ui-g-2 form-control">
        <span class="label" [ngClass]="{'required': !fields.address_number.nullable}">{{ fields.address_number.keyName }}</span>
        <input pInputText type="text" formControlName="address_number" />
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="formBasic" [validation]="fields.address_number"></app-validation-msg>
      </div>
      <div class="ui-g-6 form-control required">
        <span class="label" [ngClass]="{'required': !fields.country_id.nullable}">{{ fields.country_id.keyName }}</span>
        <p-autoComplete
        [suggestions]="countries"
        [(ngModel)]="model.country"
        [ngModelOptions]="{standalone: true}"
        (completeMethod)="filterCountrySingle($event)"
        (onSelect)="onSelectCountry($event)"
        placeholder="{{ 'common.country' | translate }}"
        (onClear)="onClearCountry()"
        [minLength]="2"
        reuired="true"
        class="form-control required"
        [style]="{'width':'100%'}"
        [inputStyle]="{'width':'100%'}"
        field="name">
      </p-autoComplete>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="formBasic" [validation]="fields.country_id"></app-validation-msg>
        <div *ngIf="!formBasic.controls['country_id'].valid&&formBasic.controls['country_id'].dirty">
          <p-message severity="error" text="{{ 'common.required_error' | translate }}" *ngIf="formBasic.controls['country_id'].errors.required">
          </p-message>
        </div>
      </div>

      <div class="ui-g-4 form-control required">
        <span class="label" [ngClass]="{'required': !fields.state_id.nullable}">{{ fields.state_id.keyName }}</span>
        <p-dropdown [options]="states" [(ngModel)]="model.state" (onChange)="onSelectState($event)" [filter]="true" formControlName="state_id" [style]="{'width':'100%'}" placeholder="{{'common.select_something' | translate}}"></p-dropdown>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="formBasic" [validation]="fields.state_id"></app-validation-msg>
        <div *ngIf="!formBasic.controls['state_id'].valid&&formBasic.controls['state_id'].dirty">
          <p-message severity="error" text="{{ 'common.required_error' | translate }}" *ngIf="formBasic.controls['state_id'].errors.required">
          </p-message>
        </div>
      </div>

      <div class="ui-g-4 form-control required">
        <span class="label" [ngClass]="{'required': !fields.province_id.nullable}">{{ fields.province_id.keyName }}</span>
        <p-dropdown [options]="provinces" [filter]="true" formControlName="province_id" placeholder="{{'common.select_something' | translate}}"></p-dropdown>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="formBasic" [validation]="fields.province_id"></app-validation-msg>
        <div *ngIf="!formBasic.controls['province_id'].valid&&formBasic.controls['province_id'].dirty">
          <p-message severity="error" text="{{ 'common.required_error' | translate }}" *ngIf="formBasic.controls['province_id'].errors.required">
          </p-message>
        </div>
      </div>
      <div class="ui-g-4 form-control">
        <span class="label" [ngClass]="{'required': !fields.city.nullable}">{{ fields.city.keyName }}</span>
        <input pInputText type="text" formControlName="city" />
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="formBasic" [validation]="fields.city"></app-validation-msg>
      </div>
      <div class="ui-g-4 form-control">
        <span class="label" [ngClass]="{'required': !fields.zip_code.nullable}">{{ fields.zip_code.keyName }}</span>
        <input pInputText type="text" formControlName="zip_code" />
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="formBasic" [validation]="fields.zip_code"></app-validation-msg>
      </div>
      <div class="ui-g-4 form-control">
        <span class="label" [ngClass]="{'required': !fields.latitude.nullable}">{{ fields.latitude.keyName }}</span>
        <input pInputText type="text" formControlName="latitude" (keyup)="replaceComma('latitude')" (foo)="replaceComma('latitude')" />
        <app-validation-msg [arrayValidators]="[validators.latitude]" [(fireInvalidSubmit)]="invalidSubmit" [(form)]="formBasic" [validation]="fields.latitude"></app-validation-msg>
      </div>
      <div class="ui-g-4 form-control">
        <span class="label" [ngClass]="{'required': !fields.longitude.nullable}">{{ fields.longitude.keyName }}</span>
        <input pInputText type="text" formControlName="longitude" (keyup)="replaceComma('longitude')" (foo)="replaceComma('longitude')" />
        <app-validation-msg [arrayValidators]="[validators.longitude]" [(fireInvalidSubmit)]="invalidSubmit" [(form)]="formBasic" [validation]="fields.longitude"></app-validation-msg>
      </div>
      <div class="ui-g-4 form-control">
        <span class="label" [ngClass]="{'required': !fields.altitude.nullable}">{{ fields.altitude.keyName }}</span>
        <input pInputText type="number" formControlName="altitude" />
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="formBasic" [validation]="fields.altitude"></app-validation-msg>
      </div>

    </div>
  </div>

  <div class="card Loyalty">
    <h2>{{ 'common.storeContact' | translate }}</h2>
    <div class="ui-g ui-g-nopad form-group">

      <div class="ui-g-6 form-control">
        <span class="label" [ngClass]="{'required': !fields.contact_1.nullable}">{{ fields.contact_1.keyName }}</span>
        <input pInputText type="text" formControlName="contact_1" />
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="formBasic" [validation]="fields.contact_1"></app-validation-msg>
      </div>
      <div class="ui-g-6 form-control">
        <span class="label" [ngClass]="{'required': !fields.contact_2.nullable}">{{ 'store.operationalMail' | translate }}</span>
        <input pInputText type="text" formControlName="contact_2" />
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="formBasic" [validation]="fields.contact_2"></app-validation-msg>
      </div>
      <div class="ui-g-6 form-control">
        <span class="label" [ngClass]="{'required': !fields.email.nullable}">{{ fields.email.keyName }}</span>
        <input pInputText type="text" formControlName="email" />
        <app-validation-msg [arrayValidators]="[validators.email]" [(fireInvalidSubmit)]="invalidSubmit" [(form)]="formBasic" [validation]="fields.email"></app-validation-msg>
      </div>
      <div class="ui-g-6 form-control">
        <span class="label" [ngClass]="{'required': !fields.fax.nullable}">{{ fields.fax.keyName }}</span>
        <input pInputText type="text" formControlName="fax" />
        <app-validation-msg [arrayValidators]="[validators.phone]" [(fireInvalidSubmit)]="invalidSubmit" [(form)]="formBasic" [validation]="fields.fax"></app-validation-msg>
      </div>
      <div class="ui-g-4 form-control">
        <span class="label" [ngClass]="{'required': !fields.telephone_1.nullable}">{{ fields.telephone_1.keyName }}</span>
        <input pInputText type="text" formControlName="telephone_1" />
        <app-validation-msg [arrayValidators]="[validators.phone]" [(fireInvalidSubmit)]="invalidSubmit" [(form)]="formBasic" [validation]="fields.telephone_1"></app-validation-msg>
      </div>
      <div class="ui-g-4 form-control">
        <span class="label" [ngClass]="{'required': !fields.telephone_2.nullable}">{{ fields.telephone_2.keyName }}</span>
        <input pInputText type="text" formControlName="telephone_2" />
        <app-validation-msg [arrayValidators]="[validators.phone]" [(fireInvalidSubmit)]="invalidSubmit" [(form)]="formBasic" [validation]="fields.telephone_2"></app-validation-msg>
      </div>
      <div class="ui-g-4 form-control">
        <span class="label" [ngClass]="{'required': !fields.telephone_3.nullable}">{{ fields.telephone_3.keyName }}</span>
        <input pInputText type="text" formControlName="telephone_3" />
        <app-validation-msg [arrayValidators]="[validators.phone]" [(fireInvalidSubmit)]="invalidSubmit" [(form)]="formBasic" [validation]="fields.telephone_3"></app-validation-msg>
      </div>
      <div class="ui-g-12 form-control">
        <span class="label" [ngClass]="{'required': !fields.note_1.nullable}">{{ fields.note_1.keyName }}</span>
        <input pInputText type="text" formControlName="note_1" />
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="formBasic" [validation]="fields.note_1"></app-validation-msg>
      </div>
      <div class="ui-g-12 form-control">
        <span class="label" [ngClass]="{'required': !fields.note_2.nullable}">{{ fields.note_2.keyName }}</span>
        <input pInputText type="text" formControlName="note_2" />
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="formBasic" [validation]="fields.note_2"></app-validation-msg>
      </div>
      <div class="ui-g-12 form-control">
        <span class="label" [ngClass]="{'required': !fields.note_3.nullable}">{{ fields.note_3.keyName }}</span>
        <input pInputText type="text" formControlName="note_3" />
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="formBasic" [validation]="fields.note_3"></app-validation-msg>
      </div>

    </div>
  </div>

</form>



// WEBPACK FOOTER //
// ./src/app/views/administration/store/store-common-basic/store-common-basic.component.html